/* ============================================================
   規則類效果的結算層
   ============================================================

   使用者 2026-08-02 的回饋：「池子選擇仍然太多加數值加倍率，**改玩法的不多**」。

   問題出在架構而不是資料：被動只有 `mods()` 一條出口，而 `mods` 只能表達
   「某個數值乘多少加多少」。想做「受傷時會爆炸」「衝刺留下殘影」這類效果，
   在原本的結構裡**沒有地方可以放** —— 所以池子自然而然全長成加成。

   這一層就是那個缺掉的出口。做法沿用 `sim/meta-parts.ts` 的 `GRANT`：
   持有狀態改變時重算一次，模擬層各處只讀 `RULE.xxx`。

   為什麼不讓被動自己註冊回呼：回呼會把「誰在什麼時候被呼叫」散到十幾個檔案裡，
   而且順序取決於取得順序 —— 那正是 `sim/stats.ts` 開頭說的那個坑。
   結算成一張表之後，讀的人只看得到「現在這條規則的強度是多少」，順序無關。 */

import { passives } from './loadout';

export var RULE = {
  /** 受傷時對周圍造成傷害（過載排氣）。0 = 沒有這條規則。 */
  ventDmg: 0,
  /** 鎖定目標死亡時，把衝擊值轉移給下一個目標的比例（鎖定共鳴）。 */
  relay: 0,
  /** 敵人踉蹌結束時的爆炸傷害（踉蹌爆發）。 */
  staggerBurst: 0,
  /** 衝刺結束時在起點留下的爆炸傷害（殘影）。 */
  afterimage: 0,
  /** 靜止夠久之後的傷害倍率（磁軌校準）。1 = 沒有加成。 */
  anchorMul: 1,
  /** 擊殺時掉落修復包的機率（回收協定）。 */
  salvage: 0
};

/* 每一條的等級表。放在這裡而不是各自的被動裡，是為了讓
   「這條規則在第 N 級有多強」可以一眼看完 —— 分散在資料檔裡的話
   平衡的時候要開六個地方。 */
var TABLE = {
  'p-vent': function (lv) { RULE.ventDmg = 26 + lv * 16; },
  'p-relay': function (lv) { RULE.relay = Math.min(1, 0.3 + lv * 0.14); },
  'p-burst': function (lv) { RULE.staggerBurst = 34 + lv * 26; },
  'p-afterimage': function (lv) { RULE.afterimage = 22 + lv * 15; },
  'p-anchor': function (lv) { RULE.anchorMul = 1 + lv * 0.22; },
  'p-salvage': function (lv) { RULE.salvage = 0.02 + lv * 0.018; }
};

/** 重算。任何會改變持有狀態的動作之後都要呼叫（`take()` 已經接好）。 */
export function recalcRules() {
  RULE.ventDmg = 0; RULE.relay = 0; RULE.staggerBurst = 0;
  RULE.afterimage = 0; RULE.anchorMul = 1; RULE.salvage = 0;
  for (var i = 0; i < passives.length; i++) {
    var f = TABLE[passives[i].id];
    if (f) f(passives[i].lv);
  }
}
